<title>Help Videos</title>
<layout>layout</layout>
<template>
  <div class="box no-margin">
    <div class="box-header">
      <h3 class="box-title">
        <span>{{ t('menu.help_videos') }}</span>
      </h3>
    </div>
    <div class="box-body clearfix">
      <ul class="no-bullet">
        <li v-for="video in videos">
          <a href="#" class="text-large videoLink" @click="showVideo(video)">
            <i class="fa fa-video-camera text-black fa-fw"></i>
            {{ video.title }}
          </a>
        </li>
      </ul>
    </div>
    <Modal
      v-if="showLoadingModal"
      size="medium"
      :show-close-button="true"
      @close="showLoadingModal = false">
        <h3>{{title}}</h3>
        <video id="player" autoplay="true" controls :src="url"></video>
    </Modal>
  </div>
</template>

<script>
import Modal from '~/components/Ui/Modal.vue';

export default {
  components: {
    Modal,
  },

  props: ['data'],

  data() {
    return {
      videos: [],
      showLoadingModal: false,
      url: '',
      title: '',
    }
  },

  mounted() {
    this.videos = this.data.videos
  },

  methods: {
    showVideo(video) {
      this.showLoadingModal = true
      this.url              = video.url
      this.title            = video.title
    }
  }
};
</script>
<style scoped>
    #player {
      width: 100%;
      height: 100%;
    }
</style>
